<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created: function () {
    // console.log('Application has been created')
    this.$store.dispatch('session/initialize')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue